const routes = {
  root: '/home',
}

export default routes
